import { Pipe, PipeTransform } from '@angular/core';
import { VariablesService } from '../../services';


@Pipe({
  name: 'translatePipe'
})
export class CustomTranslatePipe implements PipeTransform {
  constructor(private vars: VariablesService) {
  }
  transform(val) {
    return this.vars.getTranslatedJsonObs(val);
  }
}
